import { Avatar } from '@pickleballinc/ui/components/ui/avatar';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { WidgetPlayersRankingsV2Data } from '@/types/ranking.types';

export interface RankingV2RowProps {
  player: WidgetPlayersRankingsV2Data;
}

export const RankingsV2Row = ({ player }: RankingV2RowProps) => {
  return (
    <div className='hover:!bg-gray-200'>
      <CustomLink
        href={`/rankings/players/${player.playerSlug || player.playerUuid}?type=player-profile`}
        aria-label={`Player: ${player.firstNameInitial} ${player.lastName}, Rank: ${player.ranking}`}
      >
        <div className='flex items-center px-4 py-2'>
          <div className='w-8 shrink-0 text-left text-xs font-bold'>
            {player.isTied ? `T ${player.ranking}` : player.ranking}
          </div>
          <Avatar
            firstName={player.firstNameInitial}
            lastName={player.lastName}
            src={player.profileImage}
            size='xs'
            variant='gray'
            className='mr-2'
          />
          <div className='w-[126px] truncate text-sm text-gray-900 mr-1'>
            {player.firstNameInitial}
            <span className='mr-1' />
            <b>{player.lastName}</b>
            <span className='mr-1' />
            {player.nameSuffix}
          </div>
          <div className='w-5'>
            <ImageWithFallback
              src={player.countryImage ? player.countryImage : undefined}
              className='fill size-5 rounded-full'
              alt={`${player.playerCountryAbbreviation} flag`}
              width={20}
              height={20}
            />
          </div>
          <div className='w-[58px] shrink-0 text-right text-xs font-bold'>{player.points}</div>
        </div>
      </CustomLink>
    </div>
  );
};
